export enum LEGAL_STRUCTURES {
  SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
  PARTNERSHIP = 'PARTNERSHIP',
  LLS = 'LLC',
  CORPORATION = 'CORPORATION',
  S_CORPORATION = 'S_CORPORATION',
  NON_PROFIT = 'NON_PROFIT',
  OTHER = 'OTHER',
}
